import script from "./PaymentStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusBadge.vue?vue&type=style&index=0&id=72dc6d63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72dc6d63"]])

export default __exports__